import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { CheckoutState, SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect, useState } from "react";
import { UpgradeDialogSource } from "schemas/dashboard";
import { Plans } from "schemas/payments";

import BannerWrapper from "../BannerWrapper";
import { PRO_SALE_END, PRO_SALE_START } from "../helpers";

const useProSaleCountdown = () => {
  const [display, setDisplay] = useState<string | null>(null);

  useEffect(() => {
    const tick = () => {
      const now = new Date();
      if (now < PRO_SALE_START || now >= PRO_SALE_END) {
        setDisplay(null);
        return;
      }
      const distance = PRO_SALE_END.getTime() - now.getTime();
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      let text = "";
      if (days > 0) text += `${days}d `;
      if (hours > 0) text += `${hours}h `;
      if (minutes > 0) text += `${minutes}m `;
      text += `${seconds}s`;
      setDisplay(text);
    };

    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, []);

  return display;
};

const ProDiscountPriceBanner = () => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const { setOpenCheckoutDialog, setUpgradeDialogSource, subscription } =
    useContext(SubscriptionContext);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const countdown = useProSaleCountdown();

  if (!countdown) return <></>;

  const openCheckout = () => {
    setUpgradeDialogSource(UpgradeDialogSource.pro_discount_banner);
    const state: CheckoutState = {
      plan: Plans.PRO_YEARLY,
    };
    setOpenCheckoutDialog(state);
  };

  const getWording = () => {
    if (
      currentOrg?.isProUser &&
      subscription?.subscription?.planName === Plans.PRO
    ) {
      return "Pro Annual";
    } else {
      return "Pro";
    }
  };

  return (
    <BannerWrapper onClick={openCheckout}>
      <Grid
        container
        alignItems={"center"}
        justifyContent={"center"}
        sx={{ py: 0.5 }}
      >
        <Typography
          sx={{ fontSize: { xs: 10, md: 14, color: "white" } }}
          textAlign="center"
        >
          {isMobileScreen ? (
            <>🔥 {getWording()} on sale — $21.66/mo</>
          ) : (
            <>
              🔥 {getWording()} on sale — lock in <strong>$21.66/mo</strong>{" "}
              before the price goes up. Offer ends in{" "}
              <strong>{countdown}</strong>
            </>
          )}
          <Box
            component="i"
            className="fa-regular fa-arrow-right"
            sx={{ color: "white", ml: 1 }}
          />
        </Typography>
      </Grid>
    </BannerWrapper>
  );
};

export default ProDiscountPriceBanner;
